export enum ActionType {
  Mail = "mail",
  Pdf = "pdf",
  Hubspot = "hubspot",
  Validate = "validate",
}
